import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withModifiers as _withModifiers, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  slot: "content",
  class: "px-3 pb-3 pt-1"
}
const _hoisted_2 = {
  slot: "content",
  class: "pb-3 px-3 pt-1"
}
const _hoisted_3 = ["onClick"]
const _hoisted_4 = {
  slot: "content",
  class: "pb-3 px-3 pt-1"
}
const _hoisted_5 = ["onClick"]

import {
    IonAccordion,
    IonAccordionGroup,
    IonCheckbox,
    IonCol,
    IonIcon,
    IonItem,
    IonLabel,
    IonRadio,
    IonRadioGroup,
    IonRow,
    IonText
} from "@ionic/vue";
import { ref, computed, onMounted, reactive, watch } from "vue";
import { t } from "@/plugins/vue-i18n";

import FilterBase from "@/components/modal/FilterBase.vue";
import ButtonBase from "@/components/button/ButtonBase.vue";

import { useSupplierStore } from "@/stores/suppliers";
import { usePersistentStore } from "@/stores/persistent";
import { useListStore } from "@/stores/lists";

import { multiSelect } from "@/composables/viewFunctions/useList";

import { SORT_METHOD } from "@/types/enum/propEnum";
import { ION_VARIANT } from "@/types/enum/ionicEnum";
import { FilterInterfaceProps } from "@/types/props";
import { FilterInterfaceEmits } from "@/types/emits";


export default /*@__PURE__*/_defineComponent({
  __name: 'FilterInterface',
  props: {
    tempCategory: {},
    tempTags: {},
    withQuantity: { type: Boolean },
    sortDirection: {},
    supplierId: {},
    ownCategories: {},
    isList: { type: Boolean }
  },
  emits: ["back", "reset", "apply", "update:tempTags", "update:tempCategory", "update:withQuantity", "update:sortDirection"],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emit = __emit

const supplierStore = useSupplierStore()
const persistentStore = usePersistentStore()
const listStore = useListStore()

const sortOptions = reactive([
    { text: t('enumT.sortDirection.asc'), value: SORT_METHOD.ALPH_ASC },
    { text: t('enumT.sortDirection.desc'), value: SORT_METHOD.ALPH_DESC }
])

const filterValue = ref<string>('sort')

const catalogValues = computed<Record<string, boolean>>({
    get: () => {
        if (!props.tempCategory) return {}
        return props.tempCategory
    },
    set: (value) => {
        emit('update:tempCategory', value)
    }
})

const sortDirectionValue = computed<SORT_METHOD>({
    get: () => {
        return props.sortDirection
    },
    set: (value) => {
        emit('update:sortDirection', value)
    }
})
const tagValues = computed<Record<string, boolean>>({
    get: () => {
        if (!props.tempTags) return {}
        return props.tempTags
    },
    set: (value) => {
        emit('update:tempTags', value)
    }
})
const quantityModel = computed<boolean>({
    get: () => {
        return props.withQuantity ?? false
    },
    set: (value) => {
        emit('update:withQuantity', value)
    }
})

const switchToManualSorting = (): void => {
    sortDirectionValue.value = SORT_METHOD.MANUAL
    multiSelect.value = true
    emit('apply')
}

const changeAccordion = (value: string): void => {
    filterValue.value = filterValue.value === value ? '' : value
}

onMounted(() => {
    if (props.isList) sortOptions.push(...[
        { text: t('enumT.sortDirection.catSupplier'), value: SORT_METHOD.CAT_SUPPLIER },
        { text: t('enumT.sortDirection.catFilter'), value: SORT_METHOD.CAT_FILTER },
        { text: t('enumT.sortDirection.manually'), value: SORT_METHOD.MANUAL }
    ])

    if (!sortOptions.find((option) => option.value === sortDirectionValue.value)) {
        sortDirectionValue.value = props.isList ? SORT_METHOD.MANUAL : SORT_METHOD.ALPH_ASC
    }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(FilterBase, {
    onBack: _cache[6] || (_cache[6] = ($event: any) => (emit('back'))),
    onReset: _cache[7] || (_cache[7] = ($event: any) => (emit('reset'))),
    onApply: _cache[8] || (_cache[8] = ($event: any) => (emit('apply')))
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(IonAccordionGroup), { value: filterValue.value }, {
        default: _withCtx(() => [
          _createVNode(_unref(IonAccordion), { value: "sort" }, {
            default: _withCtx(() => [
              _createVNode(_unref(IonItem), {
                slot: "header",
                class: "grey4-grey4-background purple-purple-color max-width accordion-90-deg filter-accordion-header grey-accordion-toggle",
                lines: "none",
                onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (changeAccordion('sort')), ["stop"]))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('label.sort')), 1)
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_1, [
                _createVNode(_unref(IonRadioGroup), {
                  modelValue: sortDirectionValue.value,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((sortDirectionValue).value = $event)),
                  class: "max-width"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sortOptions, (option) => {
                      return (_openBlock(), _createBlock(_unref(IonRow), {
                        key: option.value,
                        onClick: ($event: any) => (sortDirectionValue.value = option.value),
                        class: "cursor-pointer"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(IonCol), { class: "center-y break-word" }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(IonRadio), {
                                mode: "md",
                                value: option.value,
                                class: "filter-checkbox"
                              }, null, 8, ["value"]),
                              _createVNode(_unref(IonLabel), { class: "ml-1 purple-purple-color fs-14" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(option.text ? option.text : _ctx.$t('label.noFilter')), 1)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
                    }), 128)),
                    (/* isList && !persistentStore.offlineMode */ /* code from Ihor -> disable button */ false)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: "center-y",
                          onClick: switchToManualSorting
                        }, [
                          _createVNode(ButtonBase, {
                            color: _unref(ION_VARIANT).GREY_4,
                            class: "round-button grey1-grey1-color inherit-color no-shadow",
                            style: {"width":"50px","height":"50px"}
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(IonIcon), {
                                src: "assets/icon/pencil.svg",
                                class: "round-button-icon"
                              })
                            ]),
                            _: 1
                          }, 8, ["color"]),
                          _createVNode(_unref(IonText), { class: "ml-1 purple-purple-color" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t('button.manualSort')), 1)
                            ]),
                            _: 1
                          })
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                (__props.isList)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createVNode(_unref(IonRow), { class: "mt-1" }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(IonCol), { class: "fs-smaller grey1-grey1-color" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t('label.quantity')), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(IonRow), null, {
                        default: _withCtx(() => [
                          _createVNode(_unref(IonCol), {
                            class: "center-y",
                            size: "6"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(IonCheckbox), {
                                mode: "md",
                                modelValue: quantityModel.value,
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((quantityModel).value = $event)),
                                class: "filter-checkbox"
                              }, null, 8, ["modelValue"]),
                              _createElementVNode("div", {
                                class: "ml-1 cursor-pointer purple-purple-color",
                                onClick: _cache[3] || (_cache[3] = ($event: any) => (emit('update:withQuantity', !__props.withQuantity)))
                              }, _toDisplayString(_ctx.$t('label.quantityBiggerZero')), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ], 64))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          }),
          (__props.isList && sortDirectionValue.value !== _unref(SORT_METHOD).MANUAL)
            ? (_openBlock(), _createBlock(_unref(IonAccordion), {
                key: 0,
                value: "tags"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonItem), {
                    slot: "header",
                    class: "grey4-grey4-background purple-purple-color max-width filter-accordion-header accordion-90-deg grey-accordion-toggle",
                    lines: "none",
                    onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (changeAccordion('tags')), ["stop"]))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('label.ownCategories')), 1)
                    ]),
                    _: 1
                  }),
                  _createElementVNode("div", _hoisted_2, [
                    (__props.ownCategories)
                      ? (_openBlock(), _createBlock(_unref(IonRow), { key: 0 }, {
                          default: _withCtx(() => [
                            (__props.ownCategories.length > 0)
                              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(__props.ownCategories, (tag) => {
                                  return (_openBlock(), _createBlock(_unref(IonCol), {
                                    key: tag.id,
                                    class: "center-y",
                                    size: "6"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(IonCheckbox), {
                                        mode: "md",
                                        modelValue: tagValues.value[tag.id],
                                        "onUpdate:modelValue": ($event: any) => ((tagValues.value[tag.id]) = $event),
                                        class: "filter-checkbox",
                                        style: {"min-width":"18px"}
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                                      _createElementVNode("div", {
                                        class: "ml-1 cursor-pointer purple-purple-color fs-14",
                                        onClick: ($event: any) => (tagValues.value[tag.id] = !tagValues.value[tag.id])
                                      }, _toDisplayString(tag.name), 9, _hoisted_3)
                                    ]),
                                    _: 2
                                  }, 1024))
                                }), 128))
                              : (_openBlock(), _createBlock(_unref(IonCol), { key: 1 }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t('messages.list.noTags')), 1)
                                  ]),
                                  _: 1
                                }))
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (sortDirectionValue.value !== _unref(SORT_METHOD).MANUAL && _unref(supplierStore).getSupplierCategoriesOptions(__props.supplierId).length > 1)
            ? (_openBlock(), _createBlock(_unref(IonAccordion), {
                key: 1,
                value: "categories"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonItem), {
                    slot: "header",
                    class: "grey4-grey4-background purple-purple-color max-width filter-accordion-header accordion-90-deg grey-accordion-toggle",
                    lines: "none",
                    onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (changeAccordion('categories')), ["stop"]))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('label.supplierCategories')), 1)
                    ]),
                    _: 1
                  }),
                  _createElementVNode("div", _hoisted_4, [
                    _createVNode(_unref(IonRow), null, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(supplierStore).getSupplierCategoriesOptions(__props.supplierId), (category) => {
                          return (_openBlock(), _createBlock(_unref(IonCol), {
                            key: category.id,
                            class: "center-y",
                            size: "6"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(IonCheckbox), {
                                mode: "md",
                                modelValue: catalogValues.value[category.id],
                                "onUpdate:modelValue": ($event: any) => ((catalogValues.value[category.id]) = $event),
                                class: "filter-checkbox",
                                style: {"min-width":"18px"}
                              }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                              _createElementVNode("div", {
                                class: "ml-1 cursor-pointer purple-purple-color fs-14",
                                onClick: ($event: any) => (catalogValues.value[category.id] = !catalogValues.value[category.id])
                              }, [
                                (category.name)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                      _createTextVNode(_toDisplayString(category.name), 1)
                                    ], 64))
                                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                      _createTextVNode(_toDisplayString(_ctx.$t('label.uncategorized')), 1)
                                    ], 64))
                              ], 8, _hoisted_5)
                            ]),
                            _: 2
                          }, 1024))
                        }), 128))
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["value"])
    ]),
    _: 1
  }))
}
}

})